/*
* list-metadata.ftl
*
* Generates static lists metadata used by:
* list={listMetadata[entity][field.name]}
*
* Expected JS shape:
* export const listMetadata = {
* "my-entity": {
* "status": [ { value: "OPEN", label: "OPEN" }, ... ],
* ...
* },
* ...
* }
*
* Assumptions (adjust if your model differs):
* - column.isList() : true if this field is a static list (hardcoded)
* - column.getListValues(): returns a list of either:
* - strings, OR
* - objects with (value,label) or (key,label) accessors/props
*/
export const listMetadata = {
};
export const getList = (entity, field) => {
const e = listMetadata?.[entity];
if (!e) return [];
const l = e?.[field];
if (!l) return [];
return l;
};